<template>
  <div :class="$style.root">
    <div :class="$style.text">There is no messages yet</div>
  </div>
</template>

<style lang="scss" module>
.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.text {
  font-size: 20px;
  font-weight: 500;
  color: #7a7a7a;
}
</style>
